module.exports = __webpack_public_path__ + "media/events/SaveTheDate-324fb016.png";